import { render, staticRenderFns } from "./MoveFile.vue?vue&type=template&id=d2016b1e"
import script from "./MoveFile.vue?vue&type=script&lang=js"
export * from "./MoveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports